import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BASE_URL } from '../../../environments/environment';
import { UsersService } from '../../services';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class MeetingsService {

	constructor(
		private http: Http,
		private router: Router,
		private toastr: ToastrService,
		private userService: UsersService
	) { }

	//Tasks
	addMeeting(data) {
		return this.http.post(`${BASE_URL}meetings/add`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				return Observable.throw(err.json());
			});
	}

	deleteMeeting(id) {
		return this.http.delete(`${BASE_URL}meetings/${id}/delete`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	editMeeting(id, data) {
		return this.http.put(`${BASE_URL}meetings/${id}/edit`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	getAllMeetings(offset, filter_term) {
		return this.http.get(`${BASE_URL}meetings?offset=${offset}&filter_term=${filter_term}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	getSpecificMeeting(id) {
		return this.http.get(`${BASE_URL}meetings/${id}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	getMeetingMembers(filter_term) {
		return this.http.get(`${BASE_URL}meetings/members?filter_term=${filter_term}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	getUserAvailability(id, data) {
		return this.http.put(`${BASE_URL}user/${id}/availability`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}
	

	//Error function
	_handleError(error) {
		console.log(error);
		if (error.status === 401 || error.status === 455 || error.status === 403) {
			const clientObject = { client_id : localStorage.getItem('clientId') };
			if ( localStorage.getItem('clientId') !== null ) { 
			this.userService.autoLogin(clientObject).subscribe(
				response => {
					localStorage.setItem('securityToken', response.security_token);
					localStorage.setItem('clientId', response.client_id);
					this.toastr.warning('Vaš sigurnosni token je istekao, bit ćete automatski ponovo prijavljeni');
					setTimeout(() => {
						location.reload();
					}, 2000);
				},
				err => {
					console.log(err);
					if(err.error_msg){
						this.toastr.error(err.error_msg);
						this.router.navigate([`/login`]);
					}
				});
			} else {
				this.router.navigate([`/login`]);
			} 
		} else {
			return Observable.throw(error.json());
		}
	}

	//Header with token
	private getToken() {
		const token = localStorage.getItem('securityToken');
		if (token) {
			const headers = new Headers({
				'Content-Type': 'application/json',
				'Securitytoken': token,
			});
			return new RequestOptions({ headers: headers });
		}
	}
}



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/services/meetings/meetings.service.ts